// src/components/BoardPack/pages/new_chart_component.jsx
import React, { useState, useEffect } from "react";
import LoadingComponent from "@/components/common/LoadingComponent";
import ErrorState from "@/components/common/ErrorStateComponent";
import NewChartComponent from "@/components/BoardPack/components/charts/NewChartComponent";

const STATIC_RESPONSE = {
  success: true,
  meta: {
    contract: "0030006",
    year: 2025,
    prevYear: 2024,
    prev2Year: 2023,
    month: "Dec",
    kpi: "ticket_count",
  },
  data: {
    "0030006 - AL HASSA ON STREET": {
      Ticket_Count: {
        "2023": {
          Jan: "98,316", Feb: "91,305", Mar: "117,029", Apr: "125,769",
          May: "82,086", Jun: "90,046", Jul: "77,629", Aug: "86,376",
          Sep: "77,449", Oct: "90,703", Nov: "96,448", Dec: "108,753",
        },
        "2024": {
          Jan: "110,559", Feb: "99,624", Mar: "125,864", Apr: "100,975",
          May: "88,271", Jun: "83,603", Jul: "80,803", Aug: "84,447",
          Sep: "81,923", Oct: "95,651", Nov: "100,113", Dec: "123,359",
        },
        "2025": {
          Jan: "106,920", Feb: "117,541", Mar: "145,486", Apr: "84,615",
          May: "96,102", Jun: "80,957", Jul: "84,333", Aug: "88,857",
          Sep: "81,442", Oct: "87,548", Nov: "95,259", Dec: "103,562",
        },
      },
    },
  },
};

const NewChartComponentPage = ({
  year     = "",
  month    = "",
  contract = "",
  page     = null,
}) => {
  const [chartData, setChartData] = useState(null);
  const [lineYear,  setLineYear]  = useState("");
  const [loading,   setLoading]   = useState(true);
  const [error,     setError]     = useState(null);

  const transformApiData = (apiData) => {
    const meta       = apiData?.meta ?? {};
    const dataObj    = apiData?.data ?? {};

    const contractNames = Object.keys(dataObj);
    if (!contractNames.length) return null;

    const contractData = dataObj[contractNames[0]];
    const kpiKeys = Object.keys(contractData);
    if (!kpiKeys.length) return null;
    const kpiObj = contractData[kpiKeys[0]];

    const parseNum = (val) => {
      if (val == null || val === "-") return 0;
      const parsed = parseFloat(String(val).replace(/[,%]/g, ""));
      return isNaN(parsed) ? 0 : parsed;
    };

    const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const years  = Object.keys(kpiObj).filter((k) => /^\d{4}$/.test(k)).sort();
    if (!years.length) return null;

    const selectedYear  = String(meta.year  ?? "");
    const selectedMonth = String(meta.month ?? "");
    const latestYr      = selectedYear || String(Math.max(...years.map(Number)));

    const result = {};
    years.forEach((yr) => {
      result[yr] = {};
      MONTHS.forEach((mon) => {
        if (yr === selectedYear && selectedMonth) {
          const selIdx = MONTHS.indexOf(selectedMonth);
          const curIdx = MONTHS.indexOf(mon);
          if (selIdx !== -1 && curIdx > selIdx) return;
        }
        result[yr][mon] = parseNum(kpiObj?.[yr]?.[mon]);
      });
    });

    return { chartData: result, lineYear: latestYr };
  };

  useEffect(() => {
    processData();
  }, []);

  const processData = () => {
    try {
      setLoading(true);
      setError(null);

      const response = STATIC_RESPONSE;

      if (response?.success) {
        const transformed = transformApiData(response);
        if (transformed) {
          setChartData(transformed.chartData);
          setLineYear(transformed.lineYear);
        }
      } else {
        setError(response?.message || "Failed to load data. Please try again later.");
      }
    } catch (err) {
      setError(err?.message || "Failed to load data. Please try again later.");
      console.error("Error processing chart data:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingComponent />;
  if (error)   return <ErrorState error={error} onRetry={processData} />;
  if (!chartData) return <ErrorState error="No data available." onRetry={processData} />;

  return (
    <NewChartComponent
      title={page?.title}
      subtitle={page?.subtitle}
      chartTitle={page?.in_chart_content_line_1}
      yAxisLabel={page?.yAxisLabel  ?? "TRANSACTIONS"}
      bottomLabel={page?.bottomLabel ?? "MONTHS"}
      chartData={chartData}
      lineYear={lineYear}
      colors={page?.colors}
    />
  );
};

export default NewChartComponentPage;